import { message } from "antd";
import React, { useEffect, useState } from "react";
import { Card, Form, FormGroup, Modal, ModalBody, Spinner } from "reactstrap";
import {
  Block,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  DeptManageTable,
  Icon,
  PaginationComponent,
  RSelect,
} from "../../../components/Component";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";

import axios from "axios";
import { useForm } from "react-hook-form";
import { authHeader } from "../../../header";
import { statusOptions } from "../options_common";
import { useDebounce } from "../../../hooks/useDebounceSearch";
import { AllowAccess } from "../../../components/BlockAccess";

export const DepartmentManagement = () => {
  const [modal, setModal] = useState({
    edit: false,
    add: false,
    view: false,
  });
  const [editId, setEditedId] = useState();

  const [formData, setFormData] = useState({
    name: "",
    status: "",
    description: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(7);
  const [manageDepart, setManageDepart] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadBtn, setIsLoadBtn] = useState(false);
  const [, setDetails] = useState({});
  const [search, setSearch] = useState("");

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const debouncedSearchTerm = useDebounce(search, 500);

  useEffect(
    () => {
      // if (debouncedSearchTerm) {
      getAllDepartments();
      setCurrentPage(1);
      // }v
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedSearchTerm] // Only call effect if debounced search term changes
  );

  const onInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const resetForm = () => {
    setFormData({
      name: "",
      status: "",
      description: "",
    });
  };

  const onFormCancel = () => {
    setModal({ edit: false, add: false });
    resetForm();
  };

  const getAllDepartments = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/admin/departments?search=${search}`, {
        headers: authHeader(),
      });
      const data = response.data;
      const resultData = data;
      if (resultData) {
        setManageDepart(resultData);
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    }
  };

  const addManageDepart = async (obj) => {
    try {
      setIsLoadBtn(true);
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/admin/departments`, obj, {
        headers: authHeader(),
      });
      const formData = await response.data;
      if (formData) {
        getAllDepartments();
        setIsLoadBtn(false);
        setIsLoading(false);
        setModal({ add: false });
        message.success({
          content: "Department Created",
          style: {
            marginTop: "20vh",
          },
        });
        resetForm();
      }
      return { formData };
    } catch (error) {
      const message = error.response;
      setIsLoadBtn(false);
      setIsLoading(false);
      setModal({ add: false });
      message.error({
        content: message.data.message,
        style: {
          marginTop: "20vh",
        },
      });
      resetForm();
      return { message };
    }
  };

  const editManageDepart = async (obj) => {
    try {
      setIsLoadBtn(true);
      const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/auth/admin/departments/${editId}`, obj, {
        headers: authHeader(),
      });
      const formData = await response.data;
      if (formData) {
        getAllDepartments();
        setIsLoadBtn(false);
        setIsLoading(false);
        setModal({ edit: false });
        message.success({
          content: "Updated Successfully",
          style: {
            marginTop: "20vh",
          },
        });
        resetForm();
      }
      return { formData };
    } catch (error) {
      const message = error.response;
      setIsLoadBtn(false);
      setIsLoading(false);
      setModal({ edit: false });
      message.error({
        content: message.data.message,
        style: {
          marginTop: "20vh",
        },
      });
      resetForm();
      return { message };
    }
  };

  const onFormSubmit = () => {
    addManageDepart(formData);
    resetForm();
    setModal({ add: false });
  };

  const onEditSubmit = () => {
    editManageDepart(formData);
    resetForm();
    setModal({ edit: false });
  };

  const onEditClick = async (items) => {
    setModal({ edit: true });
    setFormData({
      name: items.name,
      status: items.status,
      description: items.description,
      id: items.id,
    });
    setDetails(items);
    setEditedId(items.id);
  };

  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = manageDepart?.slice(indexOfFirstItem, indexOfLastItem);

  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const { errors, register, handleSubmit } = useForm();

  useEffect(() => {
    getAllDepartments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <Head title="Department Management"></Head>
      <Content>
        <Block size="lg">
          <BlockHead>
            <BlockHeadContent>
              <div className="d-flex justify-content-between align-items-center">
                <BlockTitle tag="h4">Manage Department</BlockTitle>
                <div className="d-flex align-items-center justify-center">
                  <div className="mr-2">
                    <input
                      className="form-control"
                      value={search}
                      onChange={handleSearchChange}
                      placeholder="Search Departments..."
                    />
                  </div>
                  <AllowAccess allowedRights={["CREATE_DEPARTMENT"]}>
                    <Button color="primary" onClick={() => setModal({ add: true })}>
                      <Icon name="plus"></Icon>
                      <span>Create Department</span>
                    </Button>
                  </AllowAccess>
                </div>
              </div>
            </BlockHeadContent>
          </BlockHead>
          <Card className="card-bordered card-preview">
            {isLoading ? (
              <Spinner
                color="primary"
                style={{
                  height: "3rem",
                  width: "3rem",
                  margin: "0 auto",
                }}
              />
            ) : (
              <DeptManageTable
                manageDepart={currentItems}
                modal={modal}
                onEditClick={onEditClick}
                handleView={() => setModal({ view: true })}
              />
            )}
          </Card>
          <div className="card-inner">
            {manageDepart && manageDepart.length > 0 ? (
              <PaginationComponent
                itemPerPage={itemPerPage}
                totalItems={manageDepart?.length}
                paginate={paginate}
                currentPage={currentPage}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">No department found</span>
              </div>
            )}
          </div>
        </Block>

        <Modal isOpen={modal.add} toggle={() => setModal({ add: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Add Department</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onFormSubmit)}>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Department name</label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        placeholder="Department"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.name && <span className="invalid">{errors.name.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Status</label>
                      <RSelect
                        options={statusOptions}
                        onChange={(e) => setFormData({ ...formData, status: e.value })}
                      />
                      {errors.status && <span className="invalid">{errors.status.message}</span>}
                      {/* <label className="form-label">Status</label>
                      <RSelect
                        options={formData.status}
                        onChange={(e) => setFormData({ ...formData, status: e.value })}
                      /> */}
                    </FormGroup>
                  </Col>
                  <Col size="12">
                    <FormGroup>
                      <label className="form-label">Description</label>
                      <textarea
                        name="description"
                        value={formData.description}
                        placeholder="Department description"
                        onChange={(e) => onInputChange(e)}
                        className="form-control-xl form-control no-resize"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.description && <span className="invalid">{errors.description.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        <Button color="primary" size="md" type="submit">
                          Submit
                        </Button>
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal isOpen={modal.edit} toggle={() => setModal({ edit: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Edit Department</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onEditSubmit)}>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Department name</label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        placeholder="Department"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.name && <span className="invalid">{errors.name.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Status</label>
                      <RSelect
                        value={statusOptions.find((d) => d.value === String(formData.status))}
                        options={statusOptions}
                        onChange={(e) => setFormData({ ...formData, status: e.value })}
                      />
                      {/* <label className="form-label">Status</label>
                      <RSelect
                        options={formData.status}
                        onChange={(e) => setFormData({ ...formData, status: e.value })}
                      /> */}
                    </FormGroup>
                  </Col>
                  <Col size="12">
                    <FormGroup>
                      <label className="form-label">Description</label>
                      <textarea
                        name="description"
                        value={formData.description}
                        placeholder="Department description"
                        onChange={(e) => onInputChange(e)}
                        className="form-control-xl form-control no-resize"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {/* {errors.description && <span className="invalid">{errors.description.message}</span>} */}
                    </FormGroup>
                  </Col>

                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        <Button color="primary" size="md" type="submit">
                          {isLoadBtn ? <Spinner size="sm" /> : "Update"}
                        </Button>
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};
